import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ar from './ar.json';
import screensEn from './generated/screens.en.json';
import screensAr from './generated/screens.ar.json';

// Every UI string is a key (CLAUDE.md rule 11). Hand-written keys live in en.json / ar.json; per-screen keys
// (title, subtitle, actions, fields, columns…) are generated by scripts/gen-screens.mjs into generated/.
// Keys are flat ("area.screen.element"), hence keySeparator/nsSeparator are disabled. Direction is applied by src/app/ui.ts.
export const resources = {
  en: { translation: { ...en, ...screensEn } },
  ar: { translation: { ...ar, ...screensAr } },
} as const;

export type Lang = keyof typeof resources;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  keySeparator: false,
  nsSeparator: false,
  returnNull: false,
  interpolation: { escapeValue: false },
});

export default i18n;
